import { apiFetch } from './client'
import type { LendingPosition } from '../types/lending'

export function fetchLendingPositions(portfolioId: string): Promise<LendingPosition[]> {
  return apiFetch<LendingPosition[]>(`/api/lending/${encodeURIComponent(portfolioId)}`)
}
